export default "__VITE_ASSET__BDayCuED__"